import concat from 'xstream/extra/concat'
import actions from './actions'
import intent from './intent'
import xs from 'xstream'

export function Slider ({DOM, Time}) {
  const element$ = DOM.element()
  const slides$ = DOM.select('[data-slider-slide]').elements()

  const intents = intent({DOM, Time})
  const index$ = xs.merge(
    intents.next$.mapTo(+1),
    intents.prev$.mapTo(-1),
    intents.goto$.map(index => ({type: 'goto', index})),
  )
    .fold(
      (curr, iter) =>  iter.type == 'goto'
        ? iter.index
        : curr + iter,
      0,
    )

  const init$ = xs.combine(element$, slides$)
    .take(1)
    .map(actions.init)

  const slideto$ = xs.combine(
    slides$,
    index$,
  )
    .map(([$slides, position]) => ([$slides, position % $slides.length]))
    .map(actions.setVisible)

  return {
    DOM: concat(init$, xs.merge(
      slideto$,
    )),
  }
}

export default Slider



// WEBPACK FOOTER //
// ./slider/index.js